import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from './sidebar';

const CreatorList = () => {
    const [creators, setCreators] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchText, setSearchText] = useState("");
    const [totalPages, setTotalPages] = useState(0);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const adminVerified = localStorage.getItem('adminVerified');
        console.log("adminVerified", adminVerified);
        if (adminVerified != 'true') {
            navigate('/');
        }
        fetchCreators();
    }, [currentPage, searchText]);

    const fetchCreators = async () => {
        try {
            const response = await axios.post(process.env.REACT_APP_API_URL, {
                apikey: process.env.REACT_APP_API_KEY,
                module: "admin",
                method: "getAllAdmin",
                page: currentPage,
                limit: 10,
                search_text: searchText
            });

            const jsonData = JSON.parse(response.data.body);
            if (jsonData.status === "success") {
                setIsLoading(true);
                setCreators(jsonData.result.users);
                setTotalPages(jsonData.result.pagination.totalPages);
            } else {
                setError("Failed to fetch creators");
            }
        } catch (error) {
            setError("Error fetching creators: " + error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleViewWheels = (creatorId) => {
        console.log(creatorId);
        navigate(`/creator/list?key=${creatorId}`);
    };

    const handleSearch = (e) => {
        setSearchText(e.target.value);
        setCurrentPage(1); // Reset to first page when searching
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const renderPaginationButtons = () => {
        const buttons = [];
        // For mobile, show fewer pagination buttons
        const maxButtons = window.innerWidth < 768 ? 3 : 5;

        let startPage = Math.max(1, currentPage - Math.floor(maxButtons / 2));
        let endPage = Math.min(totalPages, startPage + maxButtons - 1);

        if (endPage - startPage + 1 < maxButtons) {
            startPage = Math.max(1, endPage - maxButtons + 1);
        }

        // Add first page button
        if (startPage > 1) {
            buttons.push(
                <button
                    key={1}
                    className={`page-button ${currentPage === 1 ? 'active' : ''}`}
                    onClick={() => handlePageChange(1)}
                >
                    1
                </button>
            );
            if (startPage > 2) {
                buttons.push(<span key="ellipsis1" className="pagination-ellipsis">...</span>);
            }
        }

        // Add page buttons
        for (let i = startPage; i <= endPage; i++) {
            buttons.push(
                <button
                    key={i}
                    className={`page-button ${currentPage === i ? 'active' : ''}`}
                    onClick={() => handlePageChange(i)}
                >
                    {i}
                </button>
            );
        }

        // Add last page button
        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                buttons.push(<span key="ellipsis2" className="pagination-ellipsis">...</span>);
            }
            buttons.push(
                <button
                    key={totalPages}
                    className={`page-button ${currentPage === totalPages ? 'active' : ''}`}
                    onClick={() => handlePageChange(totalPages)}
                >
                    {totalPages}
                </button>
            );
        }

        return buttons;
    };

    return (
        <>
            <style>
                {`
                    .creator-main-container {
                        display: flex;
                        min-height: 100vh;
                        background: #f8f9fa;
                        position: relative;
                    }

                    .creator-content {
                        flex: 1;
                        padding: 2rem 3rem;
                        transition: margin-left 0.3s;
                    }

                    .sidebar-container {
                        position: fixed;
                        height: 100vh;
                        z-index: 1000;
                        transition: transform 0.3s;
                    }

                    

                    .creator-header {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 2rem;
                        flex-wrap: wrap;
                        gap: 1rem;
                    }

                    .creator-title {
                        color: #1a237e;
                        font-size: 2rem;
                        font-weight: 600;
                    }

                    .search-box {
                        padding: 0.5rem 1rem;
                        border: 1px solid #ddd;
                        border-radius: 4px;
                        width: 250px;
                        font-size: 1rem;
                    }

                    .table-container {
                        background: white;
                        border-radius: 8px;
                        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                        overflow-x: auto;
                    }

                    .data-table {
                        width: 100%;
                        border-collapse: collapse;
                        min-width: 600px;
                    }

                    .data-table th,
                    .data-table td {
                        padding: 1rem;
                        text-align: left;
                        border-bottom: 1px solid #eee;
                    }

                    .data-table th {
                        background: #f8f9fa;
                        font-weight: 600;
                        color: #333;
                    }

                    .data-table tr:hover {
                        background: #f5f5f5;
                    }

                    .view-button {
                        padding: 0.5rem 1rem;
                        background: #303f9f;
                        color: white;
                        border: none;
                        border-radius: 4px;
                        cursor: pointer;
                        transition: background 0.2s;
                    }

                    .view-button:hover {
                        background: #1a237e;
                    }

                    .pagination {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding: 1rem;
                        gap: 0.5rem;
                        flex-wrap: wrap;
                    }

                    .page-button {
                        padding: 0.5rem 1rem;
                        border: 1px solid #ddd;
                        background: white;
                        cursor: pointer;
                        border-radius: 4px;
                        min-width: 40px;
                    }

                    .page-button:disabled {
                        background: #f5f5f5;
                        cursor: not-allowed;
                    }

                    .page-button.active {
                        background: #303f9f;
                        color: white;
                        border-color: #303f9f;
                    }

                    .pagination-ellipsis {
                        padding: 0.5rem 0.25rem;
                        min-width: 24px;
                        text-align: center;
                    }

                    .loading-message {
                        text-align: center;
                        padding: 2rem;
                        color: #666;
                    }

                    .error-message {
                        text-align: center;
                        padding: 2rem;
                        color: #ef5350;
                    }

                    /* Desktop styles */
                    @media (min-width: 1024px) {
                        .sidebar-container {
                            transform: translateX(0) !important;
                        }
                        .creator-content {
                            margin-left: 280px;
                        }
                    }

                    /* Tablet styles */
                    @media (max-width: 1023px) {
                        
                        .creator-content {
                            margin-left: 0;
                            padding: 2rem 1.5rem;
                        }
                        .sidebar-container {
                            transform: translateX(-100%);
                        }
                        .sidebar-container.open {
                            transform: translateX(0);
                        }
                    }

                    /* Mobile styles */
                    @media (max-width: 767px) {
                        .creator-header {
                            flex-direction: column;
                            align-items: flex-start;
                        }
                        .search-box {
                            width: 100%;
                        }
                        .creator-content {
                            padding: 1.5rem 1rem;
                        }
                        .creator-title {
                            font-size: 1.5rem;
                            margin-top: 2rem;
                        }
                        .page-button {
                            padding: 0.4rem 0.8rem;
                            min-width: 36px;
                        }
                    }
                `}
            </style>

            <div className="creator-main-container">
                {/* <button 
                    className="mobile-menu-button" 
                    onClick={toggleMobileMenu}
                >
                    ☰
                </button> */}
                
                <div className={`sidebar-container ${isMobileMenuOpen ? 'open' : ''}`}>
                    <Sidebar />
                </div>

                <div className="creator-content">
                    <div className="creator-header">
                        <h1 className="creator-title">Creator List</h1>
                        <input
                            type="text"
                            className="search-box"
                            placeholder="Search creators..."
                            value={searchText}
                            onChange={handleSearch}
                        />
                    </div>

                    {isLoading ? (
                        <div className="loading-message">Loading creators...</div>
                    ) : error ? (
                        <div className="error-message">{error}</div>
                    ) : (
                        <div className="table-container">
                            <table className="data-table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Phone Number</th>
                                        <th>Email</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {creators.map((creator) => (
                                        <tr key={creator._id}>
                                            <td>{creator.first_name}</td>
                                            <td>{creator.phone_number}</td>
                                            <td>{creator.email_address}</td>
                                            <td>
                                                <button
                                                    className="view-button"
                                                    onClick={() => handleViewWheels(creator._id)}
                                                >
                                                    View Wheels
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <div className="pagination">
                                <button
                                    className="page-button"
                                    onClick={() => handlePageChange(currentPage - 1)}
                                    disabled={currentPage === 1}
                                >
                                    Prev
                                </button>

                                {renderPaginationButtons()}

                                <button
                                    className="page-button"
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    disabled={currentPage === totalPages}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default CreatorList;